import isEmpty from "./is-Empty";

export const getRecaptchaToken = async (executeRecaptcha, action = "form_submit") => {
  if (!executeRecaptcha) {
    console.warn("Recaptcha not ready");
    return null;
  }

  // console.log("getRecaptchaToken > ACTION:", action);

  // First attempt
  let token = await executeRecaptcha(action);
  // console.log("getRecaptchaToken > token 1:", token);

  // If token returned null → retry using a NEW action
  if (isEmpty(token)) {
    console.warn("Token is null. Retrying with different action...");

    const retryAction = action + "_retry";

    await new Promise((resolve) => setTimeout(resolve, 1000));
    token = await executeRecaptcha(retryAction);

    console.log("getRecaptchaToken > token 2:", token, " (retry action:", retryAction, ")");
  }

  return token;
};
